import { ColumnDefMeta } from './types';

export function getAlignmentClass(align: ColumnDefMeta['align']) {
  switch (align) {
    case 'right':
      return 'eye:text-right';
    case 'center':
      return 'eye:text-center';
    default:
      return 'eye:text-left';
  }
}

export function getFlexAlignmentClass(align: ColumnDefMeta['align']) {
  switch (align) {
    case 'right':
      return 'eye:justify-end';
    case 'center':
      return 'eye:justify-center';
    default:
      return 'eye:justify-start';
  }
}
